import React from 'react';
import { Alert } from 'react-bootstrap';

/**
 * #120936 — Băng cảnh báo tham số URL không hợp lệ (luật 3b của KHUON-CHUAN-DEEPLINK.md).
 *
 * Luật: tham số lạ thì BỎ QUA về mặc định của RIÊNG param đó — không trắng màn, không throw —
 * NHƯNG việc bỏ qua phải NHÌN THẤY ĐƯỢC. Cấm chỉ `console.log`: người dán link vào không có
 * cách nào biết vì sao màn hình không đúng như họ mong đợi.
 *
 * @param {Array<{name: string, raw: string, fallback: any}>} ignored
 */
const InvalidParamsNotice = ({ ignored = [], onDismiss }) => {
  if (!ignored.length) return null;

  return (
    <Alert
      variant="warning"
      dismissible={!!onDismiss}
      onClose={onDismiss}
      className="mb-3"
    >
      <strong>Đã bỏ qua tham số không hợp lệ trên đường dẫn:</strong>
      <ul className="mb-0 mt-1 ps-3">
        {ignored.map(({ name, raw, fallback }) => (
          <li key={`${name}=${raw}`}>
            <code>
              {name}={String(raw)}
            </code>{' '}
            — đang dùng mặc định{' '}
            <strong>{fallback === '' || fallback === undefined ? '(trống)' : String(fallback)}</strong>.
          </li>
        ))}
      </ul>
    </Alert>
  );
};

export default InvalidParamsNotice;
